import { createApp } from '@app/adapters/create-app'
import type { App } from 'vue'
import SfAssistantChecksModal from '../components/sf-assistant-checks-modal.vue'
import createInboxStore from '@app/application/communication/screens/inbox/store/inbox'
import { INBOX_IN_MODAL } from '@app/application/communication/screens/inbox/composables/use-inbox-url-storage'

function openAssistantModal(): void {
  const portal = document.getElementById('sf-modal-portal')
  if (!portal) return

  const mountTarget = document.createElement('div')
  portal.appendChild(mountTarget)

  const endpointParams = {
    companyId: window.Silverfin.currentCompanyId,
    ledgerId: window.Silverfin.currentLedgerId(),
    firmId: window.Silverfin.currentFirmId,
  }

  let app: App | null = createApp(SfAssistantChecksModal, {
    onClose: () => {
      if (app) {
        app.unmount()
        app = null
      }
      mountTarget.remove()
    },
  })

  const store = createInboxStore(endpointParams)
  app.use(store)
  app.provide(INBOX_IN_MODAL, true)
  app.mount(mountTarget)
}

window.onDomLoad(function ($doc) {
  const trigger = $doc[0].querySelector(
    '[data-behaviour="sf-assistant-checks-modal-trigger"]'
  ) as HTMLElement

  if (!trigger) return

  trigger.addEventListener('click', () => {
    openAssistantModal()
  })
})
